import { MQ_SMALL_ONLY, MQ_MIDLARGE, MQ_LARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base4x5, large2x1, medium2x1, medium4x5 } = IMAGE_SIZES;

const base = {
  fallbackDims: base4x5,
  sourceSets: [
    {
      layoutWidth: { value: 1148, units: 'px' },
      imageDims: large2x1,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 976, units: 'px' },
      imageDims: large2x1,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 720, units: 'px' },
      imageDims: medium2x1,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 320, units: 'px' },
      imageDims: medium4x5,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: MQ_MEDIUM,
      ratio: 2
    },
    {
      media: MQ_SMALL_ONLY,
      ratio: 4 / 5
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
